module.exports = __webpack_public_path__ + "static/media/step-2.1968448f.gif";